import '../polyfill';
import { reportHomePageLoadedDuration, reportHomePagePaintDuration } from '../../logger/homePageLoad';
import { bootstrap, appDataInitialize } from './bootstrap';
import { fetchHandleError } from '../FetchConfig';
import { handleError } from '../../lib/lib-util';
import { logFilesWhichUseBrowserCache } from '../../lib/log-cache-info';
window.addEventListener('load', function () {
    reportHomePageLoadedDuration();
    reportHomePagePaintDuration();
});
fetchHandleError(handleError);
appDataInitialize();
window.addEventListener('DOMContentLoaded', function () {
    bootstrap();
    logFilesWhichUseBrowserCache();
});
